<template>
  <!--begin::Lead Listing-->

  <div class="lead-template">
    <PageHeaderCount
      moduleType="lead"
      :dataLoading="dataLoading"
      :statusList="statusList"
      allkey="all_leads"
      countkey="lead_status_count"
    ></PageHeaderCount>
    <ListingTemplate :customClass="'lead-listing'">
      <template v-slot:body>
        <ListingHeader>
          <template v-slot:content>
            <template v-if="selectedRows.length > 0">
              <v-col cols="4" class="py-0 my-auto">
                <h1
                  class="form-title custom-nowrap-ellipsis margin-auto selected-rows-text"
                >
                  {{ totalSelected }} Selected
                </h1>
              </v-col>
              <v-col cols="8" class="py-0 justify-flex-end d-flex margin-auto">
                <template v-if="getPermission('lead:update')">
                  <v-menu
                    content-class="custom-menu-list"
                    bottom
                    offset-y
                    :close-on-click="true"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        depressed
                        :disabled="dataLoading"
                        class="mx-2 custom-grey-border custom-bold-button"
                        color="cyan white--text"
                        v-bind="attrs"
                        v-on="on"
                      >
                        <v-icon dark left>mdi-chevron-down</v-icon>Bulk Action
                      </v-btn>
                    </template>
                    <v-list>
                      <template v-for="(item, index) in bulkActions">
                        <v-list-item
                          link
                          v-on:click="updateLeadStatus(item.action)"
                          :key="index"
                        >
                          <v-list-item-icon class="margin-auto-zero mr-3 my-2">
                            <v-icon class="icon-default-blue">{{
                              item.icon
                            }}</v-icon>
                          </v-list-item-icon>
                          <v-list-item-title
                            class="font-weight-500 font-size-14"
                            >{{ item.title }}</v-list-item-title
                          >
                        </v-list-item>
                      </template>
                    </v-list>
                  </v-menu>
                </template>
                <v-btn
                  depressed
                  :disabled="dataLoading"
                  class="mx-2 custom-grey-border custom-bold-button"
                  color="red lighten-1 white--text"
                  v-on:click="clearSelections"
                >
                  <v-icon dark left>mdi-close</v-icon>Clear Selections
                </v-btn>
              </v-col>
            </template>
            <template v-else>
              <v-col cols="12" class="py-0 col-lg-6">
                <h1 class="form-title d-flex margin-auto">
                  <v-select
                    :menu-props="{ offsetY: true }"
                    :disabled="dataLoading"
                    :items="statusList"
                    v-model="status"
                    hide-details
                    item-color="cyan"
                    class="pt-0 mt-0 listing-status main-listing-status-filter"
                    item-text="text"
                    item-value="value"
                  >
                    <template v-slot:item="{ item }">
                      <v-list-item-content>
                        <v-list-item-title
                          v-text="item.text"
                        ></v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-action>
                        <v-chip
                          :color="item.color"
                          :text-color="item.textcolor"
                        >
                          <template v-if="item.value == 'all'">{{
                            item.all_leads
                          }}</template>
                          <template v-else>{{
                            item.lead_status_count
                          }}</template>
                        </v-chip>
                      </v-list-item-action>
                    </template>
                  </v-select>
                </h1>
              </v-col>
              <v-col
                cols="8"
                class="py-0 justify-flex-end d-flex margin-auto col-lg-6 all-project-btn-right"
              >
                <template v-if="getPermission('lead:create')">
                  <v-btn
                    depressed
                    :disabled="dataLoading"
                    class="mx-2 custom-bold-button custom-btn-color white--text"
                    :to="getDefaultRoute('lead.create')"
                  >
                    <v-icon dark left>mdi-plus</v-icon> Create
                  </v-btn>
                </template>
                <v-btn
                  depressed
                  :disabled="dataLoading"
                  class="mx-2 custom-grey-border custom-bold-button"
                  color="cyan white--text"
                  v-on:click="searchDialog = true"
                >
                  <v-icon dark>mdi-filter</v-icon>
                </v-btn>

                <v-menu
                  max-height="400"
                  max-width="250"
                  offset-y
                  left
                  :close-on-content-click="false"
                  content-class="white-background"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      depressed
                      :disabled="dataLoading"
                      class="mx-2 custom-bold-button btn-tab-hide"
                      color="cyan white--text"
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon dark>mdi-table-edit</v-icon>
                    </v-btn>
                  </template>
                  <draggable
                    tag="ul"
                    v-model="defaultColDefs"
                    class="draggable-group"
                    handle=".draggable-drag-icon"
                    v-on:change="updateVisible()"
                  >
                    <template v-for="cols in defaultColDefs">
                      <li
                        class="draggable-group-item"
                        :key="cols.field"
                        v-if="!cols.checkbox || Number(cols.checkbox) == 0"
                      >
                        <v-checkbox
                          dense
                          v-model="defaultColShow"
                          v-bind:value="cols.field"
                          :label="cols.headerName"
                          :disabled="Number(cols.fixed) || dataLoading"
                          color="cyan"
                          hide-details
                          class="pt-2 mt-0"
                          v-on:change="updateVisible()"
                        ></v-checkbox>
                        <v-icon
                          class="draggable-drag-icon"
                          small
                          right
                          color="cyan"
                          >mdi-drag</v-icon
                        >
                      </li>
                    </template>
                  </draggable>
                </v-menu>
                <PageTips v-if="false" module="lead"></PageTips>
              </v-col>
            </template>
          </template>
        </ListingHeader>
        <ListingSearchCriteria
          v-if="searchEnabled"
          pageModule="Lead"
          :basicSearchFields="[
            'barcode',
            'lead_name',
            'email',
            'phone_number',
            'source',
            'opportunity',
            'status',
            'assigned_user',
          ]"
          :allowedSearchFields="searchableArray"
          :result="totalRows"
        ></ListingSearchCriteria>
        <perfect-scrollbar
          :options="{ suppressScrollX: true }"
          class="scroll custom-box-top-inner-shadow"
          style="max-height: 90vh; position: relative"
        >
          <ListingTable
            :columnCount="columnLength()"
            :dataLoading="dataLoading"
            :rowData="rowData"
          >
            <template v-slot:thead>
              <thead>
                <tr>
                  <template v-for="cols in customThead">
                    <th
                      v-if="cols.visible"
                      :key="cols.id"
                      class="simple-table-th"
                      :class="{ 'checkbox-width-limit': cols.checkbox }"
                      :style="{ 'max-width': cols.width }"
                    >
                      <template
                        v-if="cols.checkbox && Number(cols.checkbox) == 1"
                      >
                        <v-checkbox
                          dense
                          :disabled="dataLoading || lodash.isEmpty(rowData)"
                          v-model="selectedAll"
                          color="cyan"
                          class="hide-margin"
                          hide-details
                        ></v-checkbox>
                      </template>
                      <template v-else>
                        <div
                          v-if="cols.sortable"
                          class="simple-table-text sortable"
                          v-on:click="
                            !dataLoading
                              ? updateSorting({
                                  field: cols.field,
                                  sort: cols.sort,
                                })
                              : 'javascript:void(0)'
                          "
                        >
                          {{ cols.headerName }}
                        </div>
                        <div v-else class="simple-table-text">
                          {{ cols.headerName }}
                        </div>
                        <template v-if="cols.sort">
                          <v-icon
                            class="simple-table-sort"
                            v-if="cols.sort == 'asc'"
                            small
                            right
                            color="cyan"
                            >mdi-sort-ascending</v-icon
                          >
                          <v-icon
                            class="simple-table-sort"
                            v-if="cols.sort == 'desc'"
                            small
                            right
                            color="cyan"
                            >mdi-sort-descending</v-icon
                          >
                        </template>
                      </template>
                    </th>
                  </template>
                </tr>
              </thead>
            </template>
            <template v-slot:tbody>
              <tbody class="custom-border-bottom">
                <template v-if="!dataLoading">
                  <template v-if="!lodash.isEmpty(rowData)">
                    <tr
                      v-for="(data, index) in rowData"
                      :key="index"
                      link
                      class="lead-listing-row"
                    >
                      <template v-for="cols in customThead">
                        <td
                          v-if="cols.visible"
                          :key="cols.id"
                          :class="{
                            'simple-table-td': !cols.checkbox,
                            'checkbox-width-limit': cols.checkbox,
                          }"
                          :style="{ 'max-width': cols.width }"
                          v-on:click="
                            Number(cols.checkbox) == 0
                              ? rowClicked(data)
                              : 'javascript:void(0)'
                          "
                        >
                          <template
                            v-if="cols.checkbox && Number(cols.checkbox) == 1"
                          >
                            <v-checkbox
                              dense
                              v-model="selectedRows"
                              v-bind:value="data.id"
                              color="cyan"
                              class="hide-margin"
                              hide-details
                            ></v-checkbox>
                          </template>
                          <template v-else-if="cols.field == 'barcode'">
                            <Barcode :barcode="data.barcode"></Barcode>
                          </template>
                          <template v-else-if="cols.field == 'company_type'">
                            <div>
                              <v-chip
                                outlined
                                small
                                color="blue "
                                label
                                class=""
                                v-if="data.company_type == 'company'"
                              >
                                <span class="font-size-16 font-weight-500">
                                  Company
                                </span>
                              </v-chip>
                              <v-chip
                                outlined
                                small
                                color="red "
                                label
                                class=""
                                v-if="data.company_type == 'personal'"
                              >
                                <span class="font-size-16 font-weight-500">
                                  Individual
                                </span>
                              </v-chip>
                            </div>
                          </template>
                          <template v-else-if="cols.field == 'lead_info'">
                            <div class="lead-listing">
                              <v-tooltip
                                top
                                max-width="400"
                                content-class="custom-top-tooltip"
                              >
                                <template v-slot:activator="{ on, attrs }">
                                  <p
                                    class="m-0 custom-nowrap-ellipsis line-climp-content"
                                    v-bind="attrs"
                                    v-on="on"
                                  >
                                    <b>Name: </b>

                                    <template v-if="data && data.lead_name">
                                      <b
                                        class="fw-500"
                                        style="font-weight: 700 !important"
                                      >
                                        <span v-if="data.lead_name.length > 20">
                                          {{
                                            data.lead_name.substring(0, 20)
                                          }}...
                                        </span>
                                        <span v-else>
                                          {{ data.lead_name }}
                                        </span>
                                      </b>
                                    </template>

                                    <em v-else class="text-muted">no name</em>
                                  </p>
                                </template>

                                <span>
                                  <b>Name: </b
                                  >{{ (data && data.lead_name) || "no name" }}
                                </span>
                              </v-tooltip>

                              <p class="m-0 custom-nowrap-ellipsis">
                                <b>Email: </b>
                                <template v-if="data && data.email">
                                  <span v-if="data.email.length > 25">
                                    {{ data.email.substring(0, 25) }}...
                                  </span>
                                  <span v-else>
                                    {{ data.email }}
                                  </span>
                                </template>
                                <em v-else class="text-muted">no email</em>
                              </p>

                              <p class="m-0 custom-nowrap-ellipsis">
                                <b>Phone: </b>
                                <template v-if="data && data.phone_number">
                                  {{ data.phone_number }}
                                </template>
                                <em v-else class="text-muted">no phone</em>
                              </p>
                            </div>
                          </template>
                          <template v-else-if="cols.field == 'source'">
                            <SelectSource
                              :source="sourceList"
                              :selected="data.source"
                              @change="currentStatus = $event"
                              v-if="false"
                            />
                            <div
                              class="lead-listing"
                              @click.stop
                              @keydown.enter.stop
                            >
                              <v-autocomplete
                                v-model.trim="data.source"
                                :items="sourceList"
                                @change="handleSourceChange(data)"
                                dense
                                flat
                                filled
                                solo
                                hide-details
                                item-color="cyan"
                                color="cyan"
                                placeholder="Source"
                                item-value="value"
                                item-text="text"
                                :menu-props="{ maxWidth: '120px' }"
                                style="
                                  width: 180px;
                                  height: 28px;
                                  min-height: 28px;
                                  padding: 0;
                                  margin: 0;
                                  font-size: 13px;
                                  line-height: 1.1;
                                "
                              >
                                <template v-slot:item="{ item }">
                                  <div class="d-flex align-center">
                                    <v-icon small color="cyan" class="mr-2">
                                      {{ item.icon }}
                                    </v-icon>
                                    <span>{{ item.text }}</span>
                                  </div>
                                </template>
                                <template v-slot:selection="{ item }">
                                  <div class="d-flex align-center">
                                    <v-icon small color="cyan" class="mr-1">
                                      {{ item.icon }}
                                    </v-icon>
                                    <span>{{ item.text }}</span>
                                  </div>
                                </template>

                                <template v-slot:no-data>
                                  <v-list-item>
                                    <v-list-item-title>
                                      No Source(s) Found.
                                    </v-list-item-title>
                                  </v-list-item>
                                </template></v-autocomplete
                              >
                            </div>
                          </template>
                          <template v-else-if="cols.field == 'opportunity'">
                            <div
                              class="lead-listing"
                              @click.stop
                              @keydown.enter.stop
                            >
                              <v-autocomplete
                                v-model.trim="data.opportunity"
                                :items="opportunityList"
                                @change="handleOpportunityChange(data)"
                                dense
                                flat
                                filled
                                solo
                                hide-details
                                item-color="cyan"
                                color="cyan"
                                placeholder="Select Opportunity"
                                item-value="value"
                                item-text="text"
                                :menu-props="{ maxWidth: '120px' }"
                                style="
                                  width: 160px;
                                  height: 28px;
                                  min-height: 28px;
                                  padding: 0;
                                  margin: 0;
                                  font-size: 13px;
                                  line-height: 1.1;
                                "
                              ></v-autocomplete>
                            </div>
                          </template>
                          <template v-else-if="cols.field == 'product_type'">
                            <template v-if="data.product_type">
                              <v-chip
                                small
                                color="chip-custom-blue"
                                outlined
                                label
                                style="padding: 10px"
                              >
                                <span
                                  class="font-size-16 font-weight-500 text-capitalize"
                                >
                                  {{ data.product_type }}
                                </span>
                              </v-chip>
                            </template>
                            <em v-else class="text-muted"> no product type </em>
                          </template>
                          <template v-else-if="cols.field == 'amount'">
                            <template v-if="data.amount && data.amount > 0">
                              <v-chip
                                small
                                class="py-0"
                                color="green"
                                label
                                style="
                                  white-space: nowrap;
                                  overflow: hidden;
                                  text-overflow: ellipsis;
                                  max-width: 150px;
                                "
                              >
                                <span class="text-white">
                                  <b>${{ " " + data.amount }}</b>
                                </span>
                              </v-chip>
                            </template>
                            <em v-else class="text-muted"> no amount </em>
                          </template>

                          <template v-else-if="cols.field == 'status'">
                            <template v-if="data.status">
                              <v-chip
                                small
                                :color="`${statusColor(
                                  data.status
                                )} white--text`"
                                label
                                class="mt-2"
                                style="padding: 10px"
                              >
                                <span class="font-size-16 font-weight-700">{{
                                  getFormattedText(data.status)
                                }}</span>
                              </v-chip>
                            </template>
                            <em v-else class="text-muted"> no status </em>
                          </template>

                          <template v-else-if="cols.field == 'assign_to'">
                            <template v-if="data.assigned_user">
                              <p class="m-0 custom-nowrap-ellipsis">
                                <b
                                  class="fw-500 ms-1"
                                  style="font-weight: 700 !important"
                                >
                                  {{ data.assigned_user.display_name }}
                                </b>
                              </p>
                            </template>
                            <em v-else class="text-muted">
                              no assigned user
                            </em>
                          </template>

                          <template v-else-if="cols.field == 'added_at'">
                            <TableActivity
                              v-if="!lodash.isEmpty(data.added_by)"
                              :data="data"
                            >
                              <template v-slot:first_letters>
                                {{
                                  getFirstLetters(data.added_by?.display_name)
                                }}
                              </template>
                              <template v-slot:display_name>
                                {{ data.added_by?.display_name }}
                              </template>
                              <template v-slot:date_time>
                                <!-- {{ data.created_at }} -->
                                <template
                                  v-if="getDateCountAll(data.added_at)"
                                  >{{ data.created_at }}</template
                                >
                                <template v-else>{{
                                  formatDateTime(data.added_at)
                                }}</template>
                              </template>
                              <template v-slot:format_date_time>
                                {{ formatDate(data.added_at) }}
                                {{ formatTime(data.added_at) }}
                              </template>
                            </TableActivity>
                          </template>
                          <template v-else-if="cols.field == 'updated_at'">
                            <TableActivity
                              v-if="!lodash.isEmpty(data.updated_by)"
                              :data="data"
                            >
                              <template v-slot:first_letters>
                                {{
                                  getFirstLetters(data.updated_by?.display_name)
                                }}
                              </template>
                              <template v-slot:display_name>
                                {{ data.updated_by.display_name }}
                              </template>
                              <template v-slot:date_time>
                                {{ data.modified_at }}
                              </template>
                              <template v-slot:format_date_time>
                                {{ formatDateTime(data.updated_at) }}
                              </template>
                            </TableActivity>
                          </template>
                          <template v-else>
                            <div v-html="printRowData(cols, data)"></div>
                          </template>
                        </td>
                      </template>
                    </tr>
                  </template>
                  <tr v-else-if="!dataLoading">
                    <td :colspan="15" class="py-4">
                      <p
                        class="m-0 row-not-found text-center font-weight-500 font-size-16"
                      >
                        <img
                          :src="$assetURL('media/error/empty.png')"
                          class="row-not-found-image"
                        />
                        Uhh... There are no lead at the moment.
                      </p>
                    </td>
                  </tr>
                </template>
              </tbody>
            </template>
          </ListingTable>
        </perfect-scrollbar>
        <ListingFooter
          :dataLoading="dataLoading"
          :showingFrom="showingFrom"
          :showingTo="showingTo"
          :totalRows="totalRows"
          :currentPage="currentPage"
          :totalPages="totalPages"
        ></ListingFooter>
        <v-navigation-drawer
          v-model="searchDialog"
          app
          bottom
          temporary
          stateless
          right
          :width="600"
          style="z-index: 500"
        >
          <v-card
            text
            elevation="0"
            class="d-flex flex-column h-100 custom-field"
          >
            <!-- Drawer Title -->
            <v-card-title
              class="headline dialog-custom-header text-uppercase custom-border-bottom custom-header-blue-text white-background"
            >
              <span style="font-size: 18px"> Filter Lead</span>
              <v-spacer></v-spacer>
              <v-btn icon small @click="searchDialog = false">
                <v-icon size="30">mdi-close</v-icon>
              </v-btn>
            </v-card-title>
            <!-- Drawer Content -->
            <v-card-text class="flex-grow-1 px-3">
              <perfect-scrollbar
                :options="{ suppressScrollX: true }"
                class="scroll custom-box-top-inner-shado"
                style="height: calc(100vh - 145px); position: relative"
              >
                <v-container fluid class="pt-0 custom-search-filter">
                  <v-row>
                    <v-col md="12">
                      <label
                        class="v-label font-weight-500 font-size-13 text-capitalize"
                        >Date Range</label
                      >
                      <DateRangePicker v-model="dates" placeholder="Date Range">
                      </DateRangePicker>
                      <v-menu
                        v-if="false"
                        v-model="datePicker"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <label
                            class="v-label font-weight-500 font-size-13 text-capitalize"
                            >Date Range</label
                          >
                          <v-text-field
                            dense
                            filled
                            flat
                            placeholder="Dates Range"
                            hide-details
                            solo
                            clearable
                            v-on:click:clear="dates = []"
                            prepend-inner-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            :value="formattedDate"
                            color="cyan"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          color="cyan"
                          range
                          v-model="dates"
                        ></v-date-picker>
                      </v-menu>
                    </v-col>
                    <template v-for="(field, index) in searchableArray">
                      <v-col
                        md="12"
                        class="py-1"
                        :key="index"
                        v-if="field != 'dates'"
                      >
                        <label
                          class="v-label font-weight-500 font-size-13 text-capitalize"
                          >{{ getFilterLabel(field, "Lead") }}</label
                        >
                        <v-text-field
                          v-model.trim="listingSearch[field]"
                          dense
                          filled
                          hide-details
                          :placeholder="getFilterLabel(field, 'Lead')"
                          solo
                          flat
                          clearable
                          @keydown.enter="filterRows"
                          color="cyan"
                        ></v-text-field>
                      </v-col>
                    </template>
                  </v-row>
                </v-container>
              </perfect-scrollbar>
            </v-card-text>
            <!-- Drawer Actions -->
            <v-divider class="my-0"></v-divider>
            <v-card-actions class="d-flex justify-en px-4 pb-4">
              <v-btn
                depressed
                :disabled="dataLoading"
                class="mx-2 custom-grey-border custom-bold-button"
                color="red white--text"
                v-on:click="removeFilters('clear')"
              >
                <v-icon left>mdi-close</v-icon>
                <span>Clear Filter</span>
              </v-btn>
              <v-btn
                depressed
                :disabled="dataLoading"
                class="mx-2 custom-grey-border custom-bold-button"
                color="cyan white--text"
                v-on:click="filterRows"
              >
                <v-icon left>mdi-magnify</v-icon>
                <span>Apply Filter</span>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-navigation-drawer>
        <Dialog :commonDialog="searchDialog" v-if="false">
          <template v-slot:title>Filter Lead</template>
          <template v-slot:body>
            <perfect-scrollbar
              :options="{ suppressScrollX: true }"
              class="scroll custom-box-top-inner-shadow"
              style="max-height: 90vh; position: relative"
            >
              <v-container fluid class="pt-0 custom-search-filter">
                <v-row>
                  <v-col md="6">
                    <v-menu
                      v-model="datePicker"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          dense
                          filled
                          flat
                          label="Dates Range"
                          hide-details
                          solo
                          clearable
                          v-on:click:clear="dates = []"
                          prepend-inner-icon="mdi-calendar"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          :value="formattedDate"
                          color="cyan"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        color="cyan"
                        range
                        v-model="dates"
                      ></v-date-picker>
                    </v-menu>
                  </v-col>
                  <template v-for="(field, index) in searchableArray">
                    <v-col md="6" :key="index" v-if="field != 'dates'">
                      <v-text-field
                        v-model.trim="listingSearch[field]"
                        dense
                        filled
                        hide-details
                        :label="getFilterLabel(field, 'Lead')"
                        solo
                        flat
                        clearable
                        @keydown.enter="filterRows"
                        color="cyan"
                      ></v-text-field>
                    </v-col>
                  </template>
                </v-row>
              </v-container>
            </perfect-scrollbar>
          </template>
          <template v-slot:action>
            <v-btn
              :disabled="dataLoading"
              class="mx-2 custom-grey-border custom-bold-button"
              color="cyan white--text"
              v-on:click="filterRows"
            >
              Filter
            </v-btn>
            <v-btn
              :disabled="dataLoading"
              class="mx-2 custom-grey-border custom-bold-button"
              v-on:click="searchDialog = false"
            >
              Close
            </v-btn>
          </template>
        </Dialog>
      </template>
    </ListingTemplate>
  </div>
  <!--end::Lead Listing-->
</template>

<script>
import draggable from "vuedraggable";
import CommonMixin from "@/core/plugins/common-mixin";
import ListingMixin from "@/core/plugins/listing-mixin";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { PATCH } from "@/core/services/store/request.module";
import Barcode from "@/view/pages/partials/Barcode.vue";
import TableActivity from "@/view/pages/partials/Table-Activity.vue";
import ListingTemplate from "@/view/pages/partials/Listing-Template.vue";
import ListingTable from "@/view/pages/partials/Listing-Table.vue";
import ListingHeader from "@/view/pages/partials/Listing-Header.vue";
import ListingFooter from "@/view/pages/partials/Listing-Footer.vue";
import ListingSearchCriteria from "@/view/pages/partials/Listing-Search-Criteria.vue";
import Dialog from "@/view/pages/partials/Dialog.vue";
import PageTips from "@/view/layout/extras/offcanvas/PageTips.vue";
import PageHeaderCount from "@/view/pages/partials/PageHeaderCount.vue";
import SelectSource from "@/view/pages/partials/SelectSource.vue";
import DateRangePicker from "@/view/components/DateRangePicker";
import { SearchEventBus } from "@/core/lib/search.lib";
export default {
  mixins: [CommonMixin, ListingMixin],
  name: "lead-list",
  data() {
    return {
      exportLoading: false,
      dates: [],
      pageModule: "lead-listing",
      routeAPI: "leads",
      routeName: "lead",
      routeDetailName: "lead.detail",
      status: "all",
      menu: false,
      statusList: [],

      opportunityList: [
        {
          text: "High Chance",
          value: "High Chance",
        },
        {
          text: "50 50",
          value: "50 50",
        },
        {
          text: "Low Chance",
          value: "Low Chance",
        },
        {
          text: "None",
          value: "None",
        },
      ],

      sourceList: [
        {
          text: "Web Enquiry",
          value: "Web Enquiry",
          icon: "mdi-web",
        },
        {
          text: "Web Chat",
          value: "Web Chat",
          icon: "mdi-chat",
        },
        {
          text: "Email Marketer",
          value: "Email Marketer",
          icon: "mdi-email",
        },
        {
          text: "Tele Call",
          value: "Tele Call",
          icon: "mdi-phone",
        },
        {
          text: "Google Adwords",
          value: "Google Adwords",
          icon: "mdi-google",
        },
        {
          text: "Fsm/Ams",
          value: "Fsm/Ams",
          icon: "mdi-cog",
        },
        {
          text: "Facebook",
          value: "Facebook",
          icon: "mdi-facebook",
        },
        {
          text: "Referral",
          value: "Referral",
          icon: "mdi-account-group",
        },
        {
          text: "Intern",
          value: "Intern",
          icon: "mdi-school",
        },
        {
          text: "Canvassing Team",
          value: "Canvassing Team",
          icon: "mdi-account-multiple",
        },
        {
          text: "None",
          value: "None",
          icon: "mdi-minus-circle-outline",
        },
      ],
      customThead: [],
      moreActions: [
        /*{
          title: "Export Lead(s)",
          action: "export_items",
          divider: false,
          icon: "mdi-database-export"
        },
        {
          title: "Export Current View",
          action: "export_current_view",
          divider: true,
          icon: "mdi-database-export"
        },*/
        {
          title: "Refresh List",
          action: "refresh_list",
          divider: true,
          icon: "mdi-refresh",
        },
      ],
      bulkActions: [
        {
          title: "Mark as Not Contacted",
          action: "Not Contacted",
          icon: "mdi-check-all",
        },
        {
          title: "Mark as Follow Up",
          action: "Follow Up",
          icon: "mdi-check-all",
        },
        {
          title: "Mark as Meeting",
          action: "Meeting",
          icon: "mdi-check-all",
        },
        {
          title: "Mark as Converted to Customer",
          action: "Converted to Customer",
          icon: "mdi-check-all",
        },
        {
          title: "Mark as Rejected",
          action: "Rejected",
          icon: "mdi-check-all",
        },
        {
          title: "Mark as Accepted",
          action: "Accepted",
          icon: "mdi-check-all",
        },
      ],
    };
  },
  watch: {
    dates: {
      deep: true,
      immediate: true,
      handler(param) {
        if (param.length > 1) {
          this.listingSearch["dates"] = param;
        } else {
          this.listingSearch["dates"] = undefined;
        }
      },
    },
  },
  components: {
    PageHeaderCount,
    draggable,
    PageTips,
    Barcode,
    TableActivity,
    ListingTemplate,
    ListingFooter,
    ListingTable,
    ListingHeader,
    ListingSearchCriteria,
    Dialog,
    SelectSource,
    DateRangePicker,
  },
  methods: {
    removeFilters() {
      SearchEventBus.$emit("clear-search", true);
    },
    selectStatus(item) {
      this.selectedStatus = item;
      this.menu = false;
    },
    statusColor(status) {
      const statusMapping = {
        Draft: "cyan",
        "Not Contacted": "grey",
        "Follow Up": "blue",
        Meeting: "orange",
        "Converted to Customer": "cyan",
        Accepted: "green",
        Rejected: "red",
      };

      return statusMapping[status] || "grey";
    },

    getFormattedText(status) {
      if (!status) return "";
      return status
        .split("-")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
    },

    updateLeadStatus(status) {
      const _this = this;
      _this.dataLoading = true;
      _this.$store
        .dispatch(PATCH, {
          url: "leads/status",
          data: { lead: _this.selectedRows, status },
        })
        .then(() => {
          _this.getRows();
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.dataLoading = false;
        });
    },

    handleSourceChange(row) {
      // Only update if source has a valid value (not empty/null)
      if (row.source) {
        this.updateLeadSource(row);
      }
    },

    updateLeadSource(row) {
      const _this = this;
      const lead_id = row.id;
      const source = row.source;
      const url = `leads/source/${lead_id}`;
      _this.dataLoading = true;
      _this.$store
        .dispatch(PATCH, {
          url: url,
          data: { source: source },
        })
        .then(() => {
          _this.getRows();
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.dataLoading = false;
        });
    },

    handleOpportunityChange(row) {
      if (row.opportunity) {
        this.updateLeadOpportunity(row);
      }
    },

    updateLeadOpportunity(row) {
      const _this = this;
      const lead_id = row.id;
      const opportunity = row.opportunity;
      console.log(opportunity);
      const url = `leads/opportunity/${lead_id}`;
      _this.dataLoading = true;
      _this.$store
        .dispatch(PATCH, {
          url: url,
          data: { opportunity: opportunity },
        })
        .then(() => {
          _this.getRows();
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.dataLoading = false;
        });
    },

    moreAction(action) {
      const _this = this;
      switch (action) {
        case "import_items":
          break;
        case "export_items":
          _this.LeadExport();
          break;
        case "export_current_view":
          _this.exportCurrentView("lead");
          break;
        case "refresh_list":
          _this.getRows();
          break;
      }
    },
  },

  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: "Lead",
      },
    ]);
    this.getRows();
  },
  beforeMount() {
    const _this = this;
    _this.lodash.assign(_this.queryParams, _this.$route.query);

    _this.status = _this.$route.query.status || _this.status;

    _this.paginationPageSize =
      window.localStorage.getItem(_this.pageModule) || 50;
  },
};
</script>
